import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type AgentGuideFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const AgentGuideFilled = forwardRef<SVGSVGElement, AgentGuideFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-3.593954 -1.923742) scale(1.546944)">
        <path d="M8.87808 8.99897C9.57005 9.00253 10.2475 8.80064 10.8246 8.41887C11.4018 8.0371 11.8526 7.49263 12.1201 6.85442C12.3875 6.21622 12.4595 5.513 12.327 4.83383C12.1944 4.15467 11.8633 3.53013 11.3755 3.03932C10.8877 2.5485 10.2652 2.2135 9.58689 2.07675C8.90856 1.94 8.20491 2.00766 7.56506 2.27114C6.92521 2.53462 6.37796 2.98208 5.99262 3.55684C5.60729 4.1316 5.40121 4.80779 5.40048 5.49977C5.39952 6.42437 5.76491 7.3117 6.41668 7.96751C7.06845 8.62333 7.95349 8.99421 8.87808 8.99897ZM12.1973 9.79097H5.55528C4.78382 9.79097 4.04396 10.0974 3.49845 10.6429C2.95295 11.1884 2.64648 11.9283 2.64648 12.6998C2.64648 13.4712 2.95295 14.2111 3.49845 14.7566C4.04396 15.3021 4.78382 15.6086 5.55528 15.6086H8.46048L12.6005 9.81977C12.4669 9.80093 12.3322 9.79131 12.1973 9.79097ZM16.0313 12.3686C15.0377 11.6486 15.3113 11.249 14.3321 10.5398C13.9726 10.2897 13.5573 10.1315 13.1225 10.079L11.8553 11.843L9.13368 15.6554L9.45408 15.8822L11.3585 13.2182C11.6405 13.2994 11.907 13.4271 12.1469 13.5962C13.1441 14.3162 12.8669 14.7158 13.8497 15.4286C14.2999 15.717 14.8049 15.9095 15.3329 15.9938L17.5145 12.9374C16.9861 12.8523 16.4811 12.6586 16.0313 12.3686Z" />
      </g>
    </svg>
  ),
);

AgentGuideFilled.displayName = 'AgentGuideFilled';

export default AgentGuideFilled;
